var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pickup" }, [
    _c(
      "form",
      {
        staticClass: "q-gutter-lg",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.submitPickup($event)
          }
        }
      },
      [
        _c("div", { staticClass: "title" }, [
          _vm._v(
            "\n      Расформировать заказ через N часов после сборки заказа\n    "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("q-input", {
              staticClass: "form-group__control col-xs-2",
              attrs: { square: "", outlined: "", dense: "" },
              model: {
                value: _vm.vCancelInterval,
                callback: function($$v) {
                  _vm.vCancelInterval = $$v
                },
                expression: "vCancelInterval"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "intervals-header" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v("\n        Интервалы\n      ")
          ]),
          _vm._v(" "),
          _c("div", {
            directives: [{ name: "ripple", rawName: "v-ripple" }],
            staticClass: "icon",
            domProps: { innerHTML: _vm._s(_vm.icAdd) },
            on: { click: _vm.addInterval }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [_c("Intervals")], 1),
        _vm._v(" "),
        _c("div", { staticClass: "row reverse" }, [
          _c(
            "div",
            { staticClass: "col-sm-3 col-12" },
            [
              _c("q-btn", {
                staticClass: "full-width",
                attrs: {
                  type: "submit",
                  size: "16px",
                  label: "Сохранить",
                  unelevated: "",
                  color: "primary"
                }
              })
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }